// 世界觀
import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Axios from '@/shared/api/axios';
import { Link, useNavigate } from 'react-router-dom';
import PaginationDot from '@/components/ui/PaginationDot';
import { useTranslation } from 'react-i18next';
import placeholder_cover_1600x700 from "@/assets/imgs/placeholders/cover_1600x700.jpg";
import SafeImg from '@/components/shared/SafeImg';
import RelativeTime from '@/components/shared/RelativeTime';
import StatusModal from '@/components/ui/StatusModal';

const WorldView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const idolId = useSelector((state) => state.user.idolId);

  const [pageParams, setPageParams] = useState({
    page: 1,
    limit: 3,
    idol_id: idolId
  });

  const [list, setList] = useState(null);
  const [total, setTotal] = useState(null);

  // API 非成功狀態碼統一由 StatusModal 顯示（含攔截器附加的 HTTP_xxx）
  const statusModalRef = useRef(null);
  const [currentStatusCode, setCurrentStatusCode] = useState('');

  const getList = async (params) => {
    try {
      const res = await Axios.post("/world/get-list", params);
      switch (res.data.status_code) {
        case 'SYSTEM_1000':
          setList(res.data.data);
          setTotal(res.data.total);
          break;
        default:
          setCurrentStatusCode(res.data.status_code);
          statusModalRef.current?.show();
          break
      }
    } catch (error) {
      // NETWORK_ERROR 由全域 ServerErrorPage 處理，不另外顯示 modal
      if (error.httpErrorCode && error.httpErrorCode !== 'NETWORK_ERROR') {
        setCurrentStatusCode(error.httpErrorCode);
        statusModalRef.current?.show();
      } else if (!error.httpErrorCode) {
        console.error('Get world list error:', error);
      }
    }
  };

  const handlePageChange = (number) => {
    const newPageParams = { ...pageParams, page: number };
    setPageParams(newPageParams);
    getList(newPageParams);
  }

  useEffect(() => {
    getList(pageParams);
  }, [])

  return (
    <>
      <div className="mb-4">
        <div className="d-flex justify-content-between align-items-center flex-wrap-reverse gap-3 mb-3">
          <Link to="/worlds" className="link-none hover-opacity">
            <h5 className="mb-0 hover-p d-flex align-items-center">
              <FontAwesomeIcon icon={["fas", "earth-americas"]} className="me-2 text-primary" />
              <span>{t('worldview')}</span>
              <FontAwesomeIcon
                icon={["fas", "angle-right"]}
                className="ms-2"
                size="sm"
              />
            </h5>
          </Link>
          <button type="button" className="btn btn-primaryF btn-sm rounded-pill"
            onClick={() => navigate('/world-create')}>
            <FontAwesomeIcon icon={["fas", "plus"]} className="me-2" />
            {t('create_world')}
          </button>
        </div>
        {list && list.length > 0 ? (
          <div className="">
            {list.map((item) => (
              <div key={item.world_id} className="mb-3">
                <Link to={`/world-view/${item.world_uuid}`} className="link-none hover-p">
                  <div className="d-flex align-items-center gap-2 rounded mb-3 p-3 border bg-white shadowA">
                    {/* 左側：世界觀封面圖（正方形、cover） */}
                    <div className="img-md rounded overflow-hidden flex-shrink-0">
                      <SafeImg
                        src={(item.world_media && item.world_media[0] && item.world_media[0].url) || placeholder_cover_1600x700}
                        alt={item.world_title}
                      />
                    </div>
                    {/* 右側：標題 + 時間等文字資訊 */}
                    <div className="flex-grow-1">
                      <h6 className="mb-0 line-clamp-1">{item.world_title}</h6>
                      <p className="fs-12 text-gray mb-0"><RelativeTime value={item.last_comment_time} /></p>
                      <p className="fs-12 text-gray mb-0">{item.link_count}</p>
                    </div>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        ) : (
          <div className="mb-3">
            {t('no_data')}
          </div>
        )}
        {list && list.length > 0 ? (
          <PaginationDot total={total} limit={pageParams.limit} currentPage={pageParams.page} onPageChange={handlePageChange} />
        ) : ('')}
      </div>
      <StatusModal ref={statusModalRef} statusCode={currentStatusCode} />
    </>
  )
}

export default WorldView